module.exports = __webpack_public_path__ + "static/media/download-btn-w@3x.98a69236.png";